var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main",attrs:{"id":"ManagePageTitle"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"description"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }